export default {
  tab: '{title}',
  save: 'Guardar',
  addToFolder: 'Guardar en Carpeta',
  contactAuthor: 'Contactar al autor',
  classPlan: 'Plan de clases',
  resourceObjective: 'Objetivos pedagógicos',
  organization: 'Organización',
  classDistribution: 'Distribución',
  teacherTrigger: 'Disparador Docente',
  time: 'Tiempo',
  start: 'Inicio',
  development: 'Desarrollo',
  closure: 'Cierre',
  materials: 'Material Necesarios',
  download: 'Descargar',
  downloadAll: 'Descargar todo',
  downloadableMaterial: 'Contenido descargable',
  valuation: 'Sugerencias de evaluación',
  minutes: 'minutos',
  ageSeparator: 'a',
  years: 'años',
  share: 'Compartir',
  getInfo: 'Solicitar información',
  classOrganization: {
    individual: 'Individual',
    smallgroups: 'Grupal/Individual',
    group: 'Grupal',
    0: ''
  },
  classPlanLayout: {
    row: 'Filas',
    group: 'Grupos',
    circle: 'Círculo',
    halfCircle: 'Medio círculo'
  },
  class: 'Clase {classNumber}',
  classWithName: 'Clase {classNumber} - {name}',
  seeRegister: 'Ver registro de uso',
  registerUse: 'Registrar uso'
}

export const en = {
  tab: '{title}',
  save: 'Save',
  addToFolder: 'Save to Folder',
  contactAuthor: 'Contact author',
  classPlan: 'Lesson plan',
  resourceObjective: 'Resource objectives',
  organization: 'Organization',
  classDistribution: 'Layout',
  teacherTrigger: 'Teacher trigger',
  time: 'Time',
  start: 'Start',
  development: 'Development',
  closure: 'Closure',
  materials: 'Required materials',
  download: 'Download',
  downloadAll: 'Download all',
  downloadableMaterial: 'Downloadable content',
  valuation: 'Assessment suggestions',
  minutes: 'minutes',
  ageSeparator: 'to',
  years: 'years',
  share: 'Share',
  getInfo: 'Request information',
  classOrganization: {
    individual: 'Individually',
    smallgroups: 'Groups/Individually',
    group: 'Groups',
    0: ''
  },
  classPlanLayout: {
    row: 'Rows',
    group: 'Groups',
    circle: 'Circle',
    halfCircle: 'Half circle'
  },
  class: 'Class {classNumber}',
  classWithName: 'Class {classNumber} - {name}',
  seeRegister: 'View usage record',
  registerUse: 'Register usage'
}

export const ca = {
  tab: '{title}',
  save: 'Desa',
  addToFolder: 'Afegeix a la Carpeta',
  contactAuthor: 'Posa\'m en contacte amb l\'autor',
  classPlan: 'Pla de classes',
  resourceObjective: 'Objectiu del recurs',
  organization: 'Organització',
  classDistribution: 'Distribució',
  teacherTrigger: 'Disparador Docent',
  time: 'Temps',
  start: 'Inici',
  development: 'Desenvolupament',
  closure: 'Tancament',
  materials: 'Material Necessaris',
  download: 'Descarrega',
  downloadAll: 'Descarrega-ho tot',
  downloadableMaterial: 'Contingut descarregable',
  valuation: 'Suggeriments d\'avaluació',
  minutes: 'minuts',
  ageSeparator: 'a',
  years: 'anys',
  share: 'Comparteix',
  getInfo: 'Sol·licitar informació',
  classOrganization: {
    individual: 'Individual',
    smallgroups: 'Grupal/Individual',
    group: 'Grupal',
    0: ''
  },
  classPlanLayout: {
    row: 'Files',
    group: 'Grups',
    circle: 'Cercle',
    halfCircle: 'Mig cercle'
  },
  class: 'Classe {classNumber}',
  classWithName: 'Classe {classNumber} - {name}',
  seeRegister: 'Veure registre d\'ús',
  registerUse: 'Registrar ús'
}
